import { render, staticRenderFns } from "./RoomHeader.vue?vue&type=template&id=5ceb97bc&scoped=true&"
import script from "./RoomHeader.vue?vue&type=script&lang=js&"
export * from "./RoomHeader.vue?vue&type=script&lang=js&"
import style0 from "./RoomHeader.vue?vue&type=style&index=0&id=5ceb97bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceb97bc",
  null
  
)

export default component.exports